import * as React from 'react';

import { DialogActionsBar } from '@progress/kendo-react-dialogs';
import { TextArea } from '@progress/kendo-react-inputs';

import Button from 'src/components/design-system/Button';
import useReceiptDetails from 'src/hooks/useReceiptDetails';

interface IReceiptNotesWizard {
  showModal: (modalName: string, data?: any) => void;
  receiptNote: string;
}

const ReceiptNotesWizard: React.FC<IReceiptNotesWizard> = ({ showModal, receiptNote }) => {
  const [note, setNote] = React.useState(receiptNote);
  const { updateFormData } = useReceiptDetails();
  function updateReceipt(e: any) {
    setNote(e.value);
    updateFormData('receiptNotes', e.value);
  }
  const btnArr = [{ clickFunction: () => showModal('Receipt Notes'), child: 'Close' }];
  return (
    <>
      <div>
        <div>
          <div style={{ lineHeight: '1', marginBottom: '5px' }}>
            <b>Notes:</b>
          </div>
          <TextArea defaultValue={''} value={note} onChange={updateReceipt} />
        </div>
        <DialogActionsBar>
          <div style={{ display: 'flex', justifyContent: 'end' }}>
            {btnArr.map((btnObj: any) => (
              <Button key={btnObj.child} color="info" onClick={btnObj.clickFunction}>
                {btnObj.child}
              </Button>
            ))}
          </div>
        </DialogActionsBar>
      </div>
    </>
  );
};

export default ReceiptNotesWizard;
